import { useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useIsomorphicLayoutEffect } from "~/hooks/useIsomorphicLayoutEffect";

gsap.registerPlugin(ScrollTrigger);

const FillText = ({
  text,
  className,
  textType = "heading",
}: {
  text: string;
  className?: string;
  textType?: "heading" | "paragraph";
}) => {
  const textRef = useRef<HTMLHeadingElement | HTMLParagraphElement>(null);

  useIsomorphicLayoutEffect(() => {
    if (!textRef.current) return;

    const ctx = gsap.context(() => {
      gsap.to(textRef.current, {
        ease: "power1.inOut",
        backgroundSize: "100% 100%",
        scrollTrigger: {
          trigger: textRef.current,
          start: "top 80%",
          end: "bottom 40%",
          scrub: 1,
        },
      });
    });

    return () => ctx.revert();
  }, []);

  return (
    <div className={className}>
      {textType === "heading" ? (
        <h1 className="fill-text" ref={textRef}>
          {text}
        </h1>
      ) : (
        <p className="fill-text" ref={textRef}>
          {text}
        </p>
      )}
    </div>
  );
};

export default FillText;
